import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.css';
import { AutoComplete, Button, Col, Input, Row } from 'antd';
import { Route, useLocation, Switch, useHistory } from 'react-router-dom';
import { useRef } from 'react';


const SearchBar = (options) => {
    const ref = useRef()
    const history = useHistory();
    const [selectedOption, setSelectedOption] = React.useState('');
    const [inputValue, setInputValue] = React.useState('');

    const onSelect = (data, option) => {
        history.push(option.value)
        setSelectedOption(option);
        setInputValue(option.label); 
    };

    const onChange = (data, option) => {
        setInputValue(data);
        setSelectedOption(option);
    };

    return (
        <Row>
            <Col xs={0} xl={24} span={24}>
                <AutoComplete
                    size='small'
                    value={inputValue}
                    options={options}
                    autoFocus={true}
                    style={{ width: '100%' }}
                    filterOption={(inputValue, option) =>
                        option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onSelect={onSelect}
                    onChange={onChange}
                >
                    <Input.Search placeholder='Tìm kiếm' />
                </AutoComplete>
            </Col>
            <Col xs={24} xl={0} span={24}>

                <AutoComplete
                    placeholder='Tìm kiếm'
                    value={inputValue}
                    options={options}
                    autoFocus={true}
                    style={{ width: '100%' }}
                    filterOption={(inputValue, option) =>
                        option.label.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                    }
                    onSelect={onSelect}
                    onChange={onChange}
                >
                </AutoComplete>
            </Col>
        </Row>

    );
};

export default SearchBar
